var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 3.33335V7.50002H3.81825M3.81825 7.50002C4.37146 6.13179 5.36299 4.98578 6.63744 4.24157C7.9119 3.49737 9.39725 3.19703 10.8607 3.38764C12.3242 3.57824 13.6831 4.24902 14.7244 5.29483C15.7657 6.34065 16.4306 7.70241 16.6149 9.16669M3.81825 7.50002H7.49992M16.6666 16.6667V12.5H16.1824M16.1824 12.5C15.6284 13.8674 14.6366 15.0126 13.3623 15.7561C12.0879 16.4996 10.603 16.7996 9.14 16.6091C7.67697 16.4185 6.31842 15.7482 5.27703 14.7031C4.23564 13.658 3.57021 12.2971 3.38492 10.8334M16.1824 12.5H12.4999",
    stroke: "#232325",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ccd111889157a97a1cbd309ec34e7ce0.svg";
export { ForwardRef as ReactComponent };